import { Action, createReducer, on } from '@ngrx/store';
import {
  approveMarketedProperty,
  approveMarketedPropertyFailure,
  approveMarketedPropertySuccess,
  getMarketedProperties,
  getMarketedPropertiesFailure,
  getMarketedPropertiesSuccess,
  rejectMarketedProperty,
  rejectMarketedPropertyFailure,
  rejectMarketedPropertySuccess,
} from './marketed-properties.action';
import { MarketedProperty } from './marketed-properties.model';

export interface MarketedPropertiesState {
  list: MarketedProperty[];
  loading: boolean;
  error: any;
  pageNumber: number | null;
  pageSize: number | null;
  totalPages: number | null;
  totalRecords: number | null;
}

export const initialState: MarketedPropertiesState = {
  list: [],
  loading: false,
  error: null,
  pageNumber: null,
  pageSize: null,
  totalPages: null,
  totalRecords: null,
};

function normalizePagedResult(data: any) {
  const pagedData = data?.result?.result ? data.result : data;

  return {
    list: (pagedData?.result || []) as MarketedProperty[],
    pageNumber: (pagedData?.pageNumber ?? null) as number | null,
    pageSize: (pagedData?.pageSize ?? null) as number | null,
    totalPages: (pagedData?.totalPages ?? null) as number | null,
    totalRecords: (pagedData?.totalRecords ?? null) as number | null,
  };
}

export const MarketedPropertiesReducer = createReducer(
  initialState,
  on(
    getMarketedProperties,
    approveMarketedProperty,
    rejectMarketedProperty,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),

  on(getMarketedPropertiesSuccess, (state, { data }) => {
    const normalized = normalizePagedResult(data);

    return {
      ...state,
      list: normalized.list,
      pageNumber: normalized.pageNumber,
      pageSize: normalized.pageSize,
      totalPages: normalized.totalPages,
      totalRecords: normalized.totalRecords,
      loading: false,
    };
  }),

  on(
    approveMarketedPropertySuccess,
    rejectMarketedPropertySuccess,
    (state) => ({
      ...state,
      loading: false,
    }),
  ),

  on(
    getMarketedPropertiesFailure,
    approveMarketedPropertyFailure,
    rejectMarketedPropertyFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),
  ),
);

export function reducer(
  state: MarketedPropertiesState | undefined,
  action: Action,
) {
  return MarketedPropertiesReducer(state, action);
}
